// Trilingual translations: French, English, Arabic

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      products: "Produits",
      retail: "Gamme Retail",
      bulk: "Olion Vrac",
      industrial: "Solutions Industrielles",
      box: "Olion Box",
      about: "À Propos",
      capacity: "Notre Capacité",
      partners: "Devenez Partenaire",
      locations: "Points de Vente",
      contact: "Contact",
      catalog: "Catalogue",
      shop: "Boutique en ligne",
      industrial: "Solutions B2B"
    },
    // Hero Section
    hero: {
      slogan: "La propreté, notre fierté",
      subtitle: "Votre partenaire de confiance pour une hygiène parfaite",
      description: "Découvrez notre gamme complète de plus de 70 produits innovants pour un éclat irréprochable au quotidien, disponible dans plus de 150 points de vente à travers la Tunisie.",
      cta1: "Découvrir nos produits",
      cta2: "Devenir partenaire",
      stats: {
        experience: "Ans d'expérience",
        products: "Produits disponibles",
        pointsOfSale: "Points de vente"
      }
    },
    // Product Categories
    categories: {
      title: "Nos 4 Gammes de Produits",
      subtitle: "Des solutions adaptées à chaque besoin",
      retail: {
        title: "Gamme Retail",
        subtitle: "Supermarchés & Revendeurs",
        description: "Plus de 70 références prêtes pour les rayons des supermarchés avec packaging attractif et codes-barres conformes."
      },
      bulk: {
        title: "Olion Vrac",
        subtitle: "Économie & Écologie",
        description: "Vente en fûts de 20L pour les points de revente. Solution économique pour le consommateur final."
      },
      industrial: {
        title: "Solutions Industrielles",
        subtitle: "HORECA & Entreprises",
        description: "Formulations adaptées aux besoins spécifiques des hôtels, restaurants et cafés."
      },
      box: {
        title: "L'Olion Box",
        subtitle: "Service à Domicile",
        description: "Packs familiaux personnalisables livrés gratuitement partout en Tunisie."
      }
    },
    // Catalog
    catalog: {
      title: "Catalogue Digital",
      subtitle: "Explorez nos 70+ produits",
      filterAll: "Tous les produits",
      download: "Télécharger le catalogue PDF",
      addToQuote: "Demander un devis",
      viewDetails: "Voir détails",
      viewAll: "Voir tous les produits",
      buyNow: "Acheter en ligne",
      availableProducts: "produits disponibles dans notre catalogue complet",
      shopDesc: "Commandez directement depuis notre boutique en ligne",
      pricePerUnit: "Prix unitaire",
      cartonQty: "Qté/Carton"
    },
    // About & Capacity
    about: {
      title: "Excellence & Innovation",
      subtitle: "Notre Engagement Qualité",
      description: "Leader tunisien dans la fabrication de détergents, Olion s'engage à fournir des produits de haute qualité testés en laboratoire.",
      laboratory: "Contrôle Qualité en Laboratoire",
      labDesc: "Équipements digitaux de pointe : pH-mètres, mesures de viscosité pour garantir la stabilité de chaque lot.",
      production: "Capacité de Production",
      productionDesc: "Infrastructure moderne avec 3 véhicules équipés GPS pour une livraison rapide dans toute la Tunisie.",
      certification: "Certifications & Normes",
      certificationDesc: "Conformité aux normes internationales, produits testés et certifiés.",
      // Technology Section
      techHeader: "TECHNOLOGIE & QUALITÉ",
      techTitle: "L'Intelligence au Service de la Propreté",
      techSubtitle: "Une excellente combinaison pour renforcer la crédibilité d'Olion auprès des grands comptes industriels et de la grande distribution.",
      odooPartner: "Partenaire de Gestion Intelligente",
      innovation: "Innovation",
      tech1Title: "Production Pilotée par IA (Odoo ERP)",
      tech1Desc: "Nous utilisons la puissance du système Odoo pour coordonner nos centres de travail, garantissant une capacité de production optimale pour nos 70+ références.",
      tech2Title: "Contrôle Qualité Digitalisé",
      tech2Desc: "Chaque lot de production subit des tests de rigueur via des pH-mètres et des instruments de mesure de viscosité digitaux, avec un enregistrement automatique des résultats pour une traçabilité totale.",
      tech3Title: "Ponctualité Garantie par la Technologie",
      tech3Desc: "L'utilisation combinée de l'IA de planification et du tracking GPS nous permet de réduire les délais de livraison et de vous assurer un approvisionnement constant pour vos clients finaux.",
      tech4Title: "Engagement Satisfaction Client",
      tech4Desc: "Notre système analyse en continu les retours clients pour adapter nos formulations et proposer des solutions flexibles aux besoins spécifiques du secteur HORECA et industriel.",
      traceability: "Traçabilité totale:",
      traceabilityDesc: "Enregistrement automatique et analyse en temps réel pour une qualité constante",
      statsAI: "Production Intelligente",
      statsQuality: "Contrôle Qualité",
      statsGPS: "Suivi Temps Réel",
      statsClients: "Clients Satisfaits"
    },
    // Partners
    becomePartner: {
      title: "Devenez Partenaire Olion",
      subtitle: "Une Opportunité Clés en Main",
      concept: "Concept Clés en Main",
      conceptDesc: "Olion s'occupe de tout : livraison, aménagement du magasin (rayonnages, mobilier), enseigne lumineuse et publicité.",
      support: "Soutien Total",
      supportDesc: "Flexibilité de paiement, livraison réactive avec nos 3 véhicules suivis par GPS et coaching marketing.",
      benefits: "Avantages Partenaire",
      benefit1: "Installation complète du point de vente",
      benefit2: "Formation et accompagnement",
      benefit3: "Livraison rapide garantie",
      benefit4: "Marges attractives",
      cta: "Demander une étude gratuite"
    },
    // Locations
    locations: {
      title: "Nos Points de Vente",
      subtitle: "Plus de 200 points de vente à travers la Tunisie",
      findNearest: "Trouvez le point de vente le plus proche",
      findNearestDesc: "Contactez-nous pour connaître le distributeur le plus proche de chez vous",
      allRegions: "Toutes les régions",
      pointsOfSale: "Points de Vente",
      acrossTunisia: "À travers la Tunisie",
      distributionByRegion: "Distribution par Région",
      governorate: "Gouvernorat",
      regionPos: "Points de vente",
      totalTunisia: "TOTAL TUNISIE",
      activePos: "Points de vente actifs"
    },
    // Contact
    contact: {
      title: "Contactez-nous",
      subtitle: "Notre équipe à votre écoute",
      header: "CONTACT",
      name: "Nom complet",
      email: "Email",
      emailCommercial: "Email Commercial",
      phone: "Téléphone",
      company: "Entreprise",
      message: "Message",
      subject: "Sujet",
      send: "Envoyer",
      address: "Adresse",
      addressValue: "Route Gremda KM 12, Sfax – Tunisie",
      emailValue: "contact@olion-group.com",
      emailCommercialValue: "commercial@olion-group.com",
      phoneValue: "+216 99 804 002 / +216 99 806 004",
      workingHours: "Horaires",
      workingHoursValue: "Lun - Sam: 8h00 - 18h00",
      needInfo: "Besoin d'informations ?",
      needInfoDesc: "Notre équipe est disponible pour répondre à toutes vos questions sur nos produits et services.",
      callNow: "Appelez maintenant",
      sendMessage: "Envoyez-nous un message",
      yourNamePlaceholder: "Votre nom",
      yourEmailPlaceholder: "votre@email.com",
      yourPhonePlaceholder: "+216 XX XXX XXX",
      subjectPlaceholder: "Sujet de votre message",
      messagePlaceholder: "Votre message...",
      messageSent: "Message envoyé !",
      thankYou: "Merci pour votre message. Nous vous répondrons dans les plus brefs délais."
    },
    // Retail Selection page (Supermarket-owner-targeted overview)
    selection: {
      badge: "Sélection Supermarchés & Revendeurs",
      title: "Notre Assortiment Retail",
      subtitle: "Une vue d'ensemble organisée par famille, parfum et format — pour faciliter vos référencements en rayon.",
      stats: { families: "familles", variants: "parfums", skus: "références" },
      familyMeta: "{variants} parfums · {skus} formats",
      familyMetaSingleVariant: "{skus} formats disponibles",
      availableSizes: "Formats disponibles",
      viewDetails: "Voir la fiche produit",
      jumpTo: "Aller à",
      ctaTitle: "Vous êtes acheteur supermarché ?",
      ctaDesc: "Recevez nos tarifs, fiches techniques et conditions de référencement par e-mail.",
      ctaButton: "Demander notre offre revendeur",
      downloadPdf: "Télécharger le catalogue PDF",
    },
    // Footer
    footer: {
      description: "Leader tunisien dans la fabrication de détergents de haute qualité. Excellence et innovation au cœur de chaque produit.",
      quickLinks: "Liens Rapides",
      ourProducts: "Nos Produits",
      contactHeader: "Contact",
      followUs: "Suivez-nous",
      rights: "Tous droits réservés",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation"
    }
  },
  en: {
    nav: {
      home: "Home",
      products: "Products",
      retail: "Retail Range",
      bulk: "Olion Bulk",
      industrial: "Industrial Solutions",
      box: "Olion Box",
      about: "About",
      capacity: "Our Capacity",
      partners: "Become a Partner",
      locations: "Points of Sale",
      contact: "Contact",
      catalog: "Catalog",
      shop: "Online Shop",
      industrial: "B2B Solutions"
    },
    hero: {
      slogan: "Cleanliness, our pride",
      subtitle: "Your trusted partner for perfect hygiene",
      description: "Discover our complete range of over 70 innovative products for impeccable daily cleaning, available in more than 150 points of sale across Tunisia.",
      cta1: "Discover our products",
      cta2: "Become a partner",
      stats: {
        experience: "Years of experience",
        products: "Available products",
        pointsOfSale: "Points of sale"
      }
    },
    categories: {
      title: "Our 4 Product Lines",
      subtitle: "Solutions adapted to every need",
      retail: {
        title: "Retail Range",
        subtitle: "Supermarkets & Retailers",
        description: "Over 70 references ready for supermarket shelves with attractive packaging and compliant barcodes."
      },
      bulk: {
        title: "Olion Bulk",
        subtitle: "Economy & Ecology",
        description: "Sale in 20L drums for retail points. Economical solution for the end consumer."
      },
      industrial: {
        title: "Industrial Solutions",
        subtitle: "HORECA & Companies",
        description: "Formulations adapted to the specific needs of hotels, restaurants and cafes."
      },
      box: {
        title: "The Olion Box",
        subtitle: "Home Delivery Service",
        description: "Customizable family packs delivered free throughout Tunisia."
      }
    },
    catalog: {
      title: "Digital Catalog",
      subtitle: "Explore our 70+ products",
      filterAll: "All products",
      download: "Download PDF catalog",
      addToQuote: "Request a quote",
      viewDetails: "View details",
      viewAll: "View all products",
      buyNow: "Buy online",
      availableProducts: "products available in our complete catalog",
      shopDesc: "Order directly from our online shop",
      pricePerUnit: "Unit price",
      cartonQty: "Qty/Carton"
    },
    about: {
      title: "Excellence & Innovation",
      subtitle: "Our Quality Commitment",
      description: "Tunisian leader in detergent manufacturing, Olion is committed to providing high-quality laboratory-tested products.",
      laboratory: "Laboratory Quality Control",
      labDesc: "State-of-the-art digital equipment: pH meters, viscosity measurements to guarantee the stability of each batch.",
      production: "Production Capacity",
      productionDesc: "Modern infrastructure with 3 GPS-equipped vehicles for fast delivery throughout Tunisia.",
      certification: "Certifications & Standards",
      certificationDesc: "Compliance with international standards, tested and certified products.",
      // Technology Section
      techHeader: "TECHNOLOGY & QUALITY",
      techTitle: "Intelligence at the Service of Cleanliness",
      techSubtitle: "An excellent combination to strengthen Olion's credibility with major industrial accounts and large-scale distribution.",
      odooPartner: "Intelligent Management Partner",
      innovation: "Innovation",
      tech1Title: "AI-Driven Production (Odoo ERP)",
      tech1Desc: "We use the power of the Odoo system to coordinate our work centers, guaranteeing optimal production capacity for our 70+ references.",
      tech2Title: "Digitalized Quality Control",
      tech2Desc: "Each production batch undergoes rigorous testing via pH meters and digital viscosity measuring instruments, with automatic recording of results for total traceability.",
      tech3Title: "Punctuality Guaranteed by Technology",
      tech3Desc: "The combined use of planning AI and GPS tracking allows us to reduce delivery times and ensure a constant supply for your end customers.",
      tech4Title: "Customer Satisfaction Commitment",
      tech4Desc: "Our system continuously analyzes customer feedback to adapt our formulations and propose flexible solutions to the specific needs of the HORECA and industrial sectors.",
      traceability: "Total traceability:",
      traceabilityDesc: "Automatic recording and real-time analysis for consistent quality",
      statsAI: "Intelligent Production",
      statsQuality: "Quality Control",
      statsGPS: "Real-Time Tracking",
      statsClients: "Satisfied Customers"
    },
    becomePartner: {
      title: "Become an Olion Partner",
      subtitle: "A Turnkey Opportunity",
      concept: "Turnkey Concept",
      conceptDesc: "Olion takes care of everything: delivery, store layout (shelving, furniture), illuminated sign and advertising.",
      support: "Total Support",
      supportDesc: "Payment flexibility, responsive delivery with our 3 GPS-tracked vehicles and marketing coaching.",
      benefits: "Partner Benefits",
      benefit1: "Complete point of sale installation",
      benefit2: "Training and support",
      benefit3: "Guaranteed fast delivery",
      benefit4: "Attractive margins",
      cta: "Request a free study"
    },
    locations: {
      title: "Our Points of Sale",
      subtitle: "Over 200 points of sale across Tunisia",
      findNearest: "Find the nearest point of sale",
      findNearestDesc: "Contact us to find the distributor nearest to you",
      allRegions: "All regions",
      pointsOfSale: "Points of Sale",
      acrossTunisia: "Across Tunisia",
      distributionByRegion: "Distribution by Region",
      governorate: "Governorate",
      regionPos: "Points of sale",
      totalTunisia: "TOTAL TUNISIA",
      activePos: "Active points of sale"
    },
    contact: {
      title: "Contact Us",
      subtitle: "Our team at your service",
      header: "CONTACT",
      name: "Full name",
      email: "Email",
      emailCommercial: "Commercial Email",
      phone: "Phone",
      company: "Company",
      message: "Message",
      subject: "Subject",
      send: "Send",
      address: "Address",
      addressValue: "Route Gremda KM 12, Sfax – Tunisia",
      emailValue: "contact@olion-group.com",
      emailCommercialValue: "commercial@olion-group.com",
      phoneValue: "+216 99 804 002 / +216 99 806 004",
      workingHours: "Working Hours",
      workingHoursValue: "Mon - Sat: 8:00 AM - 6:00 PM",
      needInfo: "Need information?",
      needInfoDesc: "Our team is available to answer all your questions about our products and services.",
      callNow: "Call now",
      sendMessage: "Send us a message",
      yourNamePlaceholder: "Your name",
      yourEmailPlaceholder: "your@email.com",
      yourPhonePlaceholder: "+216 XX XXX XXX",
      subjectPlaceholder: "Subject of your message",
      messagePlaceholder: "Your message...",
      messageSent: "Message sent!",
      thankYou: "Thank you for your message. We will get back to you shortly."
    },
    selection: {
      badge: "Supermarket & Reseller Selection",
      title: "Our Retail Assortment",
      subtitle: "A clear overview organized by family, fragrance and size — designed to make shelf-listing decisions easier.",
      stats: { families: "families", variants: "fragrances", skus: "SKUs" },
      familyMeta: "{variants} fragrances · {skus} sizes",
      familyMetaSingleVariant: "{skus} sizes available",
      availableSizes: "Available sizes",
      viewDetails: "View product sheet",
      jumpTo: "Jump to",
      ctaTitle: "Are you a supermarket buyer?",
      ctaDesc: "Receive our pricing, technical sheets and reseller terms by email.",
      ctaButton: "Request our reseller offer",
      downloadPdf: "Download PDF catalog",
    },
    footer: {
      description: "Tunisian leader in the manufacturing of high-quality detergents. Excellence and innovation at the heart of every product.",
      quickLinks: "Quick Links",
      ourProducts: "Our Products",
      contactHeader: "Contact",
      followUs: "Follow Us",
      rights: "All rights reserved",
      privacy: "Privacy Policy",
      terms: "Terms of Use"
    }
  },
  ar: {
    nav: {
      home: "الرئيسية",
      products: "المنتجات",
      retail: "مجموعة التجزئة",
      bulk: "أوليون بالجملة",
      industrial: "الحلول الصناعية",
      box: "صندوق أوليون",
      about: "عن الشركة",
      capacity: "قدرتنا الإنتاجية",
      partners: "كن شريكاً",
      locations: "نقاط البيع",
      contact: "اتصل بنا",
      catalog: "الكتالوج",
      shop: "المتجر الإلكتروني",
      industrial: "حلول B2B"
    },
    hero: {
      slogan: "النظافة، فخرنا",
      subtitle: "شريكك الموثوق للنظافة المثالية",
      description: "اكتشف مجموعتنا الكاملة من أكثر من 70 منتجاً مبتكراً للتنظيف اليومي الذي لا تشوبه شائبة، متوفرة في أكثر من 150 نقطة بيع في جميع أنحاء تونس.",
      cta1: "اكتشف منتجاتنا",
      cta2: "كن شريكاً",
      stats: {
        experience: "سنوات من الخبرة",
        products: "منتجات متاحة",
        pointsOfSale: "نقاط البيع"
      }
    },
    categories: {
      title: "خطوط إنتاجنا الأربعة",
      subtitle: "حلول مناسبة لكل احتياج",
      retail: {
        title: "مجموعة التجزئة",
        subtitle: "السوبرماركت والموزعين",
        description: "أكثر من 70 منتجاً جاهزاً لرفوف السوبرماركت مع تغليف جذاب ورموز شريطية متوافقة."
      },
      bulk: {
        title: "أوليون بالجملة",
        subtitle: "الاقتصاد والبيئة",
        description: "البيع في براميل 20 لتر لنقاط البيع بالتجزئة. حل اقتصادي للمستهلك النهائي."
      },
      industrial: {
        title: "الحلول الصناعية",
        subtitle: "الفنادق والمطاعم والشركات",
        description: "تركيبات مكيفة حسب الاحتياجات المحددة للفنادق والمطاعم والمقاهي."
      },
      box: {
        title: "صندوق أوليون",
        subtitle: "خدمة التوصيل للمنازل",
        description: "عبوات عائلية قابلة للتخصيص يتم توصيلها مجاناً في جميع أنحاء تونس."
      }
    },
    catalog: {
      title: "الكتالوج الرقمي",
      subtitle: "استكشف أكثر من 70 منتجاً",
      filterAll: "جميع المنتجات",
      download: "تحميل الكتالوج PDF",
      addToQuote: "طلب عرض أسعار",
      viewDetails: "عرض التفاصيل",
      viewAll: "عرض جميع المنتجات",
      buyNow: "اشتري عبر الإنترنت",
      availableProducts: "منتج متوفر في كتالوجنا الكامل",
      shopDesc: "اطلب مباشرة من متجرنا الإلكتروني",
      pricePerUnit: "السعر للوحدة",
      cartonQty: "الكمية/كرتون"
    },
    about: {
      title: "التميز والابتكار",
      subtitle: "التزامنا بالجودة",
      description: "الشركة الرائدة في تونس في تصنيع المنظفات، أوليون ملتزمة بتوفير منتجات عالية الجودة مختبرة في المختبر.",
      laboratory: "مراقبة الجودة المخبرية",
      labDesc: "معدات رقمية متطورة: أجهزة قياس الحموضة، قياسات اللزوجة لضمان استقرار كل دفعة.",
      production: "القدرة الإنتاجية",
      productionDesc: "بنية تحتية حديثة مع 3 مركبات مزودة بنظام GPS للتوصيل السريع في جميع أنحاء تونس.",
      certification: "الشهادات والمعايير",
      certificationDesc: "الامتثال للمعايير الدولية، منتجات مختبرة ومعتمدة.",
      // Technology Section
      techHeader: "التكنولوجيا والجودة",
      techTitle: "الذكاء في خدمة النظافة",
      techSubtitle: "مزيج ممتاز لتعزيز مصداقية أوليون لدى الحسابات الصناعية الكبرى والتوزيع واسع النطاق.",
      odooPartner: "شريك الإدارة الذكية",
      innovation: "ابتكار",
      tech1Title: "الإنتاج المدار بالذكاء الاصطناعي (Odoo ERP)",
      tech1Desc: "نستخدم قوة نظام Odoo لتنسيق مراكز عملنا، مما يضمن قدرة إنتاجية مثلى لأكثر من 70 منتجاً.",
      tech2Title: "مراقبة الجودة الرقمية",
      tech2Desc: "تخضع كل دفعة إنتاج لاختبارات صارمة عبر أجهزة قياس الحموضة وأدوات قياس اللزوجة الرقمية، مع تسجيل تلقائي للنتائج لتتبع كامل.",
      tech3Title: "الدقة في المواعيد مضمونة بالتكنولوجيا",
      tech3Desc: "يتيح لنا الجمع بين الذكاء الاصطناعي للتخطيط وتتبع GPS تقليل أوقات التسليم وضمان إمداد مستمر لعملائكم النهائيين.",
      tech4Title: "التزام رضا العملاء",
      tech4Desc: "يقوم نظامنا بتحليل ملاحظات العملاء باستمرار لتكييف تركيباتنا واقتراح حلول مرنة للاحتياجات المحددة لقطاعي الفنادق والمطاعم والصناعة.",
      traceability: "التتبع الكامل:",
      traceabilityDesc: "التسجيل التلقائي والتحليل في الوقت الفعلي لجودة ثابتة",
      statsAI: "الإنتاج الذكي",
      statsQuality: "مراقبة الجودة",
      statsGPS: "التتبع الفوري",
      statsClients: "عملاء راضون"
    },
    becomePartner: {
      title: "كن شريكاً مع أوليون",
      subtitle: "فرصة متكاملة",
      concept: "مفهوم متكامل",
      conceptDesc: "أوليون تهتم بكل شيء: التوصيل، تصميم المتجر (الأرفف، الأثاث)، لافتة مضيئة وإعلانات.",
      support: "دعم كامل",
      supportDesc: "مرونة في الدفع، توصيل سريع مع مركباتنا الثلاث المتتبعة بنظام GPS والتدريب التسويقي.",
      benefits: "مزايا الشراكة",
      benefit1: "تركيب كامل لنقطة البيع",
      benefit2: "التدريب والدعم",
      benefit3: "توصيل سريع مضمون",
      benefit4: "هوامش ربح جذابة",
      cta: "طلب دراسة مجانية"
    },
    locations: {
      title: "نقاط البيع لدينا",
      subtitle: "أكثر من 200 نقطة بيع في جميع أنحاء تونس",
      findNearest: "ابحث عن أقرب نقطة بيع",
      findNearestDesc: "اتصل بنا لمعرفة أقرب موزع منك",
      allRegions: "جميع المناطق",
      pointsOfSale: "نقاط البيع",
      acrossTunisia: "في جميع أنحاء تونس",
      distributionByRegion: "التوزيع حسب المنطقة",
      governorate: "ولاية",
      regionPos: "نقاط البيع",
      totalTunisia: "إجمالي تونس",
      activePos: "نقاط بيع نشطة"
    },
    contact: {
      title: "اتصل بنا",
      subtitle: "فريقنا في خدمتك",
      header: "اتصل بنا",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      emailCommercial: "البريد التجاري",
      phone: "الهاتف",
      company: "الشركة",
      message: "الرسالة",
      subject: "الموضوع",
      send: "إرسال",
      address: "العنوان",
      addressValue: "طريق قرمدة كم 12، صفاقس - تونس",
      emailValue: "contact@olion-group.com",
      emailCommercialValue: "commercial@olion-group.com",
      phoneValue: "+216 99 804 002 / +216 99 806 004",
      workingHours: "ساعات العمل",
      workingHoursValue: "الإثنين - السبت: 8:00 صباحاً - 6:00 مساءً",
      needInfo: "هل تحتاج إلى معلومات؟",
      needInfoDesc: "فريقنا متاح للإجابة على جميع استفساراتك حول منتجاتنا وخدماتنا.",
      callNow: "اتصل الآن",
      sendMessage: "أرسل لنا رسالة",
      yourNamePlaceholder: "اسمك",
      yourEmailPlaceholder: "your@email.com",
      yourPhonePlaceholder: "+216 XX XXX XXX",
      subjectPlaceholder: "موضوع رسالتك",
      messagePlaceholder: "رسالتك...",
      messageSent: "تم إرسال الرسالة!",
      thankYou: "شكراً لرسالتك. سنرد عليك في أقرب وقت ممكن."
    },
    selection: {
      badge: "تشكيلتنا للسوبر ماركت والموزعين",
      title: "تشكيلة منتجاتنا للتجزئة",
      subtitle: "نظرة شاملة منظمة حسب العائلة والعطر والحجم — لتسهيل قرارات التوزيع على الرفوف.",
      stats: { families: "عائلات", variants: "عطور", skus: "مرجع" },
      familyMeta: "{variants} عطور · {skus} أحجام",
      familyMetaSingleVariant: "{skus} أحجام متاحة",
      availableSizes: "الأحجام المتاحة",
      viewDetails: "عرض ورقة المنتج",
      jumpTo: "انتقل إلى",
      ctaTitle: "هل أنت مشتري سوبر ماركت؟",
      ctaDesc: "احصل على قائمة الأسعار، الأوراق الفنية وشروط التوزيع عبر البريد الإلكتروني.",
      ctaButton: "اطلب عرضنا للموزعين",
      downloadPdf: "تنزيل كتالوج PDF",
    },
    footer: {
      description: "الشركة الرائدة في تونس في تصنيع المنظفات عالية الجودة. التميز والابتكار في قلب كل منتج.",
      quickLinks: "روابط سريعة",
      ourProducts: "منتجاتنا",
      contactHeader: "اتصل بنا",
      followUs: "تابعنا",
      rights: "جميع الحقوق محفوظة",
      privacy: "سياسة الخصوصية",
      terms: "شروط الاستخدام"
    }
  }
};
